
import * as _asset0 from "inline-asset:assets/galleries/ua-2021-12-09/L1001010-bw_a6f8b16811__13.jpg";
import * as _asset1 from "asset:assets/galleries/ua-2021-12-09/L1001010-bw_a6f8b16811__264.jpg";
import * as _asset2 from "asset:assets/galleries/ua-2021-12-09/L1001010-bw_a6f8b16811__529.jpg";
import * as _asset3 from "asset:assets/galleries/ua-2021-12-09/L1001010-bw_a6f8b16811__1058.jpg";


export default {
  id: "L1001010-bw",
  aspect: 0.6612410986775178,
  alt: undefined,
  sources: [{
              url: _asset0.url,
              width: 13,
            },{
              url: _asset1.url,
              width: 264,
            },{
              url: _asset2.url,
              width: 529,
            },{
              url: _asset3.url,
              width: 1058,
            }],
};
        